import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { IconButton } from '@totalsoft/rocket-ui';
import { ArrowBack } from '@mui/icons-material';

const ApprovalTypeLevelHeaderLinks = ({ approvalTypeId, siteId, onClose, onSave, disabledSave }) => {
  const { t } = useTranslation();
  return (
    <>
      <IconButton
        fontSize='medium'
        color='transparent'
        tooltip={t('ApprovalTypes.ApprovalTypeLevel.BackToList')}
        onClick={() => onClose(approvalTypeId, siteId)}
      >
        <ArrowBack />
      </IconButton>
      <IconButton
        type='save'
        fontSize='medium'
        color='transparent'
        tooltip={t('ApprovalTypes.ApprovalTypeLevel.SaveChanges')}
        onClick={onSave}
        disabled={disabledSave}
      />
    </>
  );
};

ApprovalTypeLevelHeaderLinks.propTypes = {
  onSave: PropTypes.func.isRequired,
  disabledSave: PropTypes.bool.isRequired,
  approvalTypeId: PropTypes.number.isRequired,
  siteId: PropTypes.number.isRequired,
  onClose: PropTypes.func.isRequired
};

export default ApprovalTypeLevelHeaderLinks;
